import React,{useEffect,useState} from 'react'
import toast from 'react-hot-toast';
import AdminMenu from '../../components/Layout/AdminMenu'
import Layout from '../../components/Layout/Layout'
import axios from 'axios';
import CategoryForm from '../../components/Form/CategoryForm';
import {Modal} from "antd"
import { server } from '../../App';

const CreateCategory = () => {

    const [categories,setCategories] = useState([]);
    const [name,setName] = useState("");
    const [visible,setVisible] = useState(false);
    const [selected,setSelected] = useState(null); 
    const [updatedName,setUpdatedName] = useState(""); 

    //form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const {data} = await axios.post(`${server}/api/v1/category/create-category`,{name});
            if(data.success){
                toast.success(`${name} is created`);
                getAllCategory();
            }else{
                toast.error(data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong in input form")
        }
    }

    //get all categories
    const getAllCategory = async () =>{
        try {
            const {data} = await axios.get(`${server}/api/v1/category/get-category`);
            if(data?.success){
                setCategories(data?.category);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something Went Wrong");
        }
    }

    useEffect(()=>{
        getAllCategory();
    },[]);

    //update category
    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const {data} = await axios.put(`${server}/api/v1/category/update-category/${selected._id}`,{name:updatedName});
            if(data?.success){
                toast.success(`${updatedName} is updated`);
                setSelected(null);
                setUpdatedName("");
                setVisible(false);
                getAllCategory();
            }else{
                toast.error(data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong while updating category");
        }
    };

    //delete category
    const handleDelete = async (id) => {
        try {
            const {data} = await axios.delete(`${server}/api/v1/category/delete-category/${id}`);
            if(data?.success){
                toast.success(`Category Deleted`);
                getAllCategory();
            }else{
                toast.error(data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong while deleting category");
        }
    };

  return (
    <Layout title={"Dashboard - Create Category"}>
        <div className='container-fluid m-3 p-3'>
            <div className='row'>
                <div className='col-md-3'>
                    <AdminMenu/>
                </div>
                <div className='col-md-9'>
                    <h1>Manage Category</h1>
                    <div className='p-3 w-75'>
                        <CategoryForm handleSubmit={handleSubmit} value={name} setValue={setName} />
                    </div>
                    <div className='w-75'>
                        <table className="table">
                            <thead>
                                <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {categories?.map((c)=>(
                                    <>
                                        <tr>
                                            <td key={c._id}>{c.name}</td>
                                            <td>
                                                <button className='btn btn-primary ms-2' onClick={()=>{setVisible(true);setUpdatedName(c.name); setSelected(c)}}>Edit</button>
                                                <button className='btn btn-danger ms-2' onClick={()=>handleDelete(c._id)} >Delete</button>
                                            </td>
                                        </tr>
                                    </>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Modal onCancel={()=>setVisible(false)} footer={null} visible={visible}>
                    <CategoryForm value={updatedName} setValue={setUpdatedName} handleSubmit={handleUpdate} />
                </Modal>
            </div>
        </div>
    </Layout>
  )
}

export default CreateCategory